export default __webpack_public_path__ + "static/media/hands-Correduria.11f26243.png";